import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import vuetify from "@/plugins/vuetify"; // path to vuetify export

import EventsManager from "./assets/EventsManager";
import EventManagerMenu from "./assets/EventManagerMenu";

import "vue2-toast/lib/toast.css";
import Toast from "vue2-toast";

Vue.use(VeeValidate);
Vue.use(VueResource);
Vue.use(Toast);
Vue.config.productionTip = false;
Vue.prototype.$eventsManager = new EventsManager(store);
Vue.prototype.$eventManagerMenu = new EventManagerMenu();

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
